import { createReducer, on } from '@ngrx/store';
import {Project, VerifyDeleteProjectIsValidResponse} from "../../models/project.model";
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  addProject,
  addProjectFailure,
  addProjectSuccess,
  loadProjects,
  loadProjectsFailure,
  loadProjectsSuccess,
  modifyProject,
  modifyProjectFailure,
  modifyProjectSuccess,
  removeProject,
  removeProjectFailure,
  removeProjectSuccess,
  verifyDeleteProjectIsValid,
  verifyDeleteProjectIsValidFailure,
  verifyDeleteProjectIsValidSuccess,
} from "./project.action";

export interface ProjectState {
  projects: Project[];
  verifyDeleteIsValidResponse: VerifyDeleteProjectIsValidResponse | null;
  error: string | null;
  status: StateStatus;
  deleteVerificationStatus: StateStatus;
}

export const initialState: ProjectState = {
  projects: [],
  verifyDeleteIsValidResponse: null,
  error: null,
  status: 'pending' as StateStatus,
  deleteVerificationStatus: 'pending' as StateStatus,
};

export const projectReducer = createReducer(
  initialState,
  on(loadProjects, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(loadProjectsSuccess, (state, { projects }): ProjectState => ({
    ...state,
    projects: projects,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),
  on(loadProjectsFailure, (state, { error }): ProjectState => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),

  on(removeProject, (state, { projectId }): ProjectState => ({
    ...state,
    projects: state.projects.filter((project) => project.id !== projectId),
    status: 'removing' as StateStatus
  })),
  on(removeProjectSuccess, (state, { projectId }): ProjectState => ({
    ...state,
    error: null,
    status: 'removeSuccess' as StateStatus,
  })),
  on(removeProjectFailure, (state, { error }): ProjectState => ({
    ...state,
    error: error,
    status: 'removeError' as StateStatus,
  })),

  on(verifyDeleteProjectIsValid, (state, { projectId }): ProjectState => ({
    ...state,
    deleteVerificationStatus: 'loading' as StateStatus
  })),
  on(verifyDeleteProjectIsValidSuccess, (state, {verifyDeleteIsValidResponse}): ProjectState => ({
    ...state,
    verifyDeleteIsValidResponse,
    deleteVerificationStatus: 'loadSuccess' as StateStatus,
  })),
  on(verifyDeleteProjectIsValidFailure, (state, { error }): ProjectState => ({
    ...state,
    error: error,
    deleteVerificationStatus: 'loadError' as StateStatus,
  })),

  on(addProject, (state): ProjectState => ({
    ...state,
    status: 'adding' as StateStatus,
  })),
  on(addProjectSuccess, (state, { project }): ProjectState => ({
    ...state,
    status: 'addSuccess' as StateStatus,
    projects: [
      project,
      ...state.projects
    ]
  })),
  on(addProjectFailure, (state, { error }): ProjectState => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),

  on(modifyProject, (state, { project }): ProjectState => ({
    ...state,
    status: 'modifying' as StateStatus,
    // buildKits: state.buildKits.map(originalBuildKit => {
    //   return originalBuildKit.id === buildKit.id ? {
    //       ...originalBuildKit,
    //       name: buildKit.name,
    //       description: buildKit.description,
    //       comments: buildKit.comments
    //     }
    //     : originalBuildKit;
    // })
  })),
  on(modifyProjectSuccess, (state): ProjectState => ({
    ...state,
    error: null,
    status: 'saveSuccess' as StateStatus,
  })),
  on(modifyProjectFailure, (state, { error }): ProjectState => {
    return ({
      ...state,
      error: error,
      status: 'modifyError' as StateStatus,
    });
  }),
);
